var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "Modal",
        { staticClass: "nova-overlay", on: { close: _vm.handleCloseModal } },
        [
          _c(
            "button",
            {
              staticClass: "btn-close",
              attrs: { "aria-label": "Close" },
              on: { click: _vm.handleCloseModal }
            },
            [_c("span", { staticClass: "b-sprite-global-close-black" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "b-sprite-homepage-exploding-chest icon" }),
          _vm._v(" "),
          _c("h2", [_vm._v("Welcome to Brilliant!")]),
          _vm._v(" "),
          _c("BriocheImageTag", {
            staticClass: "sponsor icon",
            attrs: { src: _vm.sponsorLogo, width: 131, alt: "Nova" }
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n    Brilliant believes that understanding the world around us is essential. That’s why we’re proud\n    to sponsor NOVA on PBS.\n  "
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-accent",
              on: { click: _vm.handleCloseModal }
            },
            [_c("span", [_vm._v("Let's go")])]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }